<template>
  <div class="StockStatusSwitcher">
    <StockStatusFutureAvailability
      v-if="shouldCheckFutureAvailability"
      :active-variant="activeVariant"
      :cart-item="cartItem"
      :total-quantity="totalQuantity"
      @set-buy-button-disabled="e => $emit('setBuyButtonDisabled', e)"
      @loading="e => $emit('loading', e)"
    />
    <StockStatus
      v-else
      :product-item="productItem"
      :cart-item="cartItem"
      :variant="activeVariant"
      :use-area="shouldUseArea"
      :is-checkout="isCheckout"
      :use-short-labels="useShortLabels"
    />
  </div>
</template>

<script setup lang="ts">
/*
This component decides what kind of stockstatus to use,
either from availability api, or data from norce
*/
import { ProductModel } from '~/models/product';
import StockStatusFutureAvailability from '~/components/product/StockStatusFutureAvailability.vue';
import StockStatus from '~/components/product/StockStatus.vue';
import { ProductVariantModel } from '~/models/productVariant';
import usePackageAreaConverter from '~/composeables/usePackageAreaConverter';
import { CartApiItem } from '~/constants/types/norce';
import { NorceInfoTypesCodes } from '~/constants/norceCodes';

interface Props {
  productItem?: ProductModel | undefined,
  activeVariant?: ProductVariantModel | undefined,
  cartItem?: CartApiItem | undefined,
  totalQuantity?: number,
  isCheckout?: boolean
  useShortLabels?: boolean
}
const props = withDefaults(defineProps<Props>(), {
  totalQuantity: 1,
  productItem: undefined,
  activeVariant: undefined,
  cartItem: undefined,
});

defineEmits<{
  (e: 'setBuyButtonDisabled', payload: boolean): void;
  (e: 'loading', payload: boolean): void;
}>();

const shouldCheckFutureAvailability = computed(()=> {
  let output = false;
  if (props.productItem?.shouldCheckFutureAvailability) {
    output = props.productItem?.shouldCheckFutureAvailability;
  } else if (props.cartItem) {
    output = props.cartItem.infoTypes?.filter((i) => i.name === NorceInfoTypesCodes.AvailableShippingDate && i.value !== '').length > 0;
  }

  return output;
});

const {
  shouldUseArea,
} = usePackageAreaConverter(toRef(()=>props.activeVariant ? props.activeVariant : props.cartItem));

</script>

<style scoped lang="postcss">
</style>
